<template>
  <div class="relative group sm:w-60 flex-shrink-0">
    <GraduationCap
      class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 w-4 h-4"
    />

    <select
      v-model="selectedClassId"
      class="w-full pl-10 py-2.5 border border-gray-300 rounded-xl bg-white text-gray-800 appearance-none shadow-sm"
      placeholder="Select Class"
    >
      <option
        disabled
        value=""
      >
        Select Class
      </option>
      <option value="null">All Classes</option>

      <option
        v-for="cls in classes.filter(
          (c) => !['passout', 'passot'].includes(c.name?.toLowerCase()),
        )"
        :key="cls._id"
        :value="cls._id"
      >
        {{ cls.name }}{{ cls.section ? ` - ${cls.section}` : "" }}
      </option>
    </select>

    <ChevronDown
      class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 w-4 h-4 pointer-events-none"
    />
  </div>
</template>

<script setup>
  import { ref, computed, watch, onMounted } from "vue";
  import { useStore } from "vuex";
  import { GraduationCap, ChevronDown } from "lucide-vue-next";

  const store = useStore();

  const selectedClassId = ref("");
  const classes = computed(() => store.getters.allClasses || []);

  const emit = defineEmits(["selected-class"]);

  onMounted(async () => {
    await store.dispatch("fetchAllClasses");
  });

  /* ✅ Emit ONLY when user selects */
  watch(selectedClassId, (val) => {
    const cls = classes.value.find((c) => c._id === val) || null;
    emit("selected-class", cls);
  });
</script>
